import React from "react";
import { Button, Upload } from "antd";
import { ReactComponent as FilePurpleIcon } from "@/assets/icons/file-purple.svg";
import { ReactComponent as AudioIcon } from "@/assets/icons/audio-bold.svg";
import { ReactComponent as DeleteIcon } from "@/assets/icons/delete.svg";
import { ReactComponent as AddIcon } from "@/assets/icons/add.svg";
import { useTranslation } from "react-i18next";
import Utils from "@/utils";
import "@/assets/audioCompress.less";

const AudioCompressWorkListRender = ({ audioCompressList, compressing, deleteAudioCompressItem, uploadProps, handleStopUpload }) => {
  const { t } = useTranslation(["audioCompress", "upload"]);
  return (
    <div className={`step-con ${compressing ? "disabled" : ""}`}>
      <div className="step-header">
        <span className="step-num active">
          <span>1</span>
        </span>
        <div className="step-item">
          <FilePurpleIcon />
          <span>{t("upload:Choose File")}</span>
          <Upload {...uploadProps} disabled={audioCompressList.length >= 5 || compressing}>
            <Button type="primary" onClick={() => handleStopUpload("add_file")} ghost icon={<AddIcon />} disabled={audioCompressList.length >= 5}>
              {t("Add file")}
            </Button>
          </Upload>
        </div>
      </div>
      <div className="step-cont">
        <div className="list">
          {audioCompressList.map(item => (
            <div className="item" key={item.guid}>
              <div className="info">
                <AudioIcon />
                <span>{Utils.omissionString(item.name, 5, 7)}</span>
              </div>
              <span>{(item.size / 1024 / 1024).toFixed(2)}MB</span>
              <DeleteIcon className="close" onClick={() => deleteAudioCompressItem(item.guid)} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AudioCompressWorkListRender;
